<template>
	<div class="vx-row w-full ml-2" ref="shareLinkPopup">
		<vs-popup
			:title="'Missions du contrat n° ' + selectedContract"
			:active.sync="isContractMissionPopupActive"
		>
			<vs-table stripe :data="selectedContractMissions" class="mt-4">
				<template slot="header">
					<h3>Prestations du contrat</h3>
				</template>
				<template slot="thead">
					<vs-th class="bgcolor white-txt">Prestations</vs-th>
					<vs-th class="bgcolor white-txt">Commentaires</vs-th>
					<vs-th class="bgcolor white-txt">Récurrence</vs-th>
					<vs-th class="bgcolor white-txt">Date début</vs-th>
					<vs-th class="bgcolor white-txt">Date fin</vs-th>
					<!-- <vs-th class="bgcolor white-txt">Temps maxi</vs-th> -->
					<vs-th class="bgcolor white-txt">Statut</vs-th>
					<vs-th class="bgcolor white-txt">Temps maxi à passer par mois</vs-th>
					<vs-th class="bgcolor white-txt">Prix Collaborateur externe</vs-th>
					<vs-th class="bgcolor white-txt"
						>Nombre de points par mois avec le client</vs-th
					>
					<!-- <vs-th v-if="showupdate == true"></vs-th> -->
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="index" v-for="(row, index) in data">
						<vs-td>{{ getProductPrestation(row.products_id) }}</vs-td>
						<vs-td class="fw-bold commentary">{{ row.commentary }}</vs-td>
						<vs-td v-if="row.recurrence"
							>{{ getContractRecurrence(row.recurrence) }} -
							{{ getContractFrequency(row.frequency) }}
						</vs-td>
						<vs-td v-else>Non</vs-td>
						<vs-td>{{ getDateToFrenchFormat(row.start_date) }}</vs-td>
						<vs-td>{{ getDateToFrenchFormat(row.end_date) }}</vs-td>
						<!-- <vs-td>{{ row.time_limit ? row.time_limit + "h" : " " }}</vs-td> -->
						<vs-td>
							<div class="flex center">
								<vs-chip
									style="width: 80px"
									:color="getContractStatusColor(row.status)"
									>{{ getContractStatus(row.status) }}</vs-chip
								>
							</div>
						</vs-td>
						<!-- <vs-td v-if="showupdate == true">
                        <vs-button
                            size="large"
                            color="primary"
                            type="flat"
                            icon-pack="feather"
                            icon="icon-edit-2"
                            @click="displayMissionForContract(true, contract, row)"
                        ></vs-button>
                    </vs-td> -->
						<vs-td>{{ row.time_limit }}</vs-td>
						<vs-td>{{
							row.provider_price_text ? row.provider_price_text + "€" : ""
						}}</vs-td>
						<vs-td>{{ row.meeting_number }}</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</vs-popup>
		<div
			style="width: 550px"
			class="vx-col mb-base px-2"
			v-for="society in displayedTasks"
			:key="society.society_name"
		>
			<vx-card style="min-width: 480px; width: 555px">
				<div class="vx-row justify-center">
					<img
						v-if="$acl.check('accountmanager')"
						alt="society-img"
						class="responsive card-img-top mx-auto"
						style="
							max-height: 150px;
							max-width: 264px;
							width: auto;
							height: auto;
						"
						:src="displaySocietyImage(society.society_id)"
						@click="displaySocietyPopup(getSocietyById(society.society_id))"
					/>
				</div>
				<div class="vx-row mx-auto justify-center mb-2">
					<div
						v-if="$acl.check('accountmanager')"
						class="vx-col"
						@click="displaySocietyPopup(getSocietyById(society.society_id))"
						style="cursor: pointer"
					>
						<h2 class="hvr-blue">{{ getSocietyName(society.society_id) }}</h2>
					</div>
					<div v-else class="vx-col">
						<h2>{{ getSocietyName(society.society_id) }}</h2>
					</div>
					<!-- <div class="vx-col">
                    <vs-button
                        class="shadow-lg"
                        type="gradient"
                        color="#27d3d2"
                        gradient-color-secondary="#35e9fd"
                        @click="displaySocietyPopup(getSocietyById(society.society_id))"
                        >Détails</vs-button
                    >
                </div> -->
				</div>
				<vx-card
					class="px-0 mb-2"
					style="width: 520px"
					v-for="(contract, index) in society.contract_list"
					:key="index"
				>
					<div class="vx-row w-auto">
						<div
							v-if="$acl.check('accountmanager')"
							class="vx-col w-1/2"
							style="cursor: pointer"
							@click="displayContractPopup(contract.contract_id)"
						>
							<span class="hvr-blue"
								><b
									>N° Contrat : {{ contract.contract_id }} -
									{{
										getProductCategoryName(
											getContractDelivery(contract.contract_id)
										)
									}}</b
								></span
							>
						</div>
						<div v-else>
							<span
								><b
									>N° Contrat : {{ contract.contract_id }} -
									{{
										getProductCategoryName(
											getContractDelivery(contract.contract_id)
										)
									}}</b
								></span
							>
						</div>
						<div class="vx-col">
							<div class="vx-row">
								<!-- <span v-for="(account_manager, index) of getAMForContractId(contract.contract_id)" :key="index"> -->
								<vx-tooltip
									v-for="(account_manager, index) of getAMForContractId(
										contract.contract_id
									)"
									:key="index"
									:text="
										account_manager.firstname + ' ' + account_manager.lastname
									"
									position="top"
								>
									<vs-avatar
										style="border: 1px solid"
										:text="
											account_manager.firstname + ' ' + account_manager.lastname
										"
										:src="getCollaboratorAvatar(account_manager.id)"
									/>
								</vx-tooltip>
								<!-- </span> -->
							</div>
						</div>
					</div>
					<div
						class="mb-2"
						style="font-size: 11px"
						v-for="(task, index) in contract.task_list"
						:key="index"
					>
						<hr v-if="index !== 0" style="color: grey" />
						<div class="vx-row mt-2" style="display: flex; align-items: center">
							<div class="vx-col px-0" style="width: 230px">
								<div style="width: 230px; display: inline-block">
									<span style="max-width: 230px">
										{{
											task.mission_id
												? getMissionProduct(task.mission_id)
												: task.commentary
										}}
									</span>
									<span v-if="task.status == 1">
										<vx-tooltip
											text="Attention, cette tâche a été modifiée après sa création."
											style="display: inline"
											><vs-icon icon="warning" color="orange"
										/></vx-tooltip>
									</span>
									<span v-else-if="task.status == 2">
										<vx-tooltip
											text="Attention, la mission de cette tâche est en pause."
											style="display: inline"
											><vs-icon icon="hourglass_disabled" color="danger"
										/></vx-tooltip>
									</span>
								</div>
								<div>
									<vx-tooltip
										v-if="task.commentary && calLen(task.commentary) > 35"
										:text="task.commentary"
										>{{ showCommentary(task.commentary) }}</vx-tooltip
									>
									{{
										task.commentary && calLen(task.commentary) <= 35
											? task.commentary
											: ""
									}}
								</div>
							</div>
							<div class="vx-col px-0" style="width: 68px; text-align: center">
								<strong>{{
									task.recurrence == 1
										? getFullDateNumber(task.creation_date)
										: ""
								}}</strong>
							</div>
							<!-- <div class="vx-col w-1/6">
                        <vs-button
                            color="primary"
                            size="large"
                            type="flat"
                            icon-pack="feather"
                            icon="icon-link-2"
                            :href="task.link"
                            target="_blank"
                        ></vs-button>
                    </div> -->
							<div class="vx-col px-0" style="width: 165px">
								<SliderWith3btn
									v-model="task.archivate"
									:id1="task.id + 'off'"
									:id2="task.id + 'null'"
									:id3="task.id + 'on'"
									styleSld="font-size: 10px; background-color: rgba(224, 224, 224, 0.78);width: 165px;"
									styleOp1="color: black; background-color: #FF0000; width:55px; padding: 5px 10px;"
									styleOp2="color: black; background-color: #FFA800; width:55px; padding: 5px 10px;"
									styleOp3="color: black; background-color: #28C76F; width:55px; padding: 5px 10px;"
									styleDefault="color: black;"
									option1="Annulé"
									option2="À faire"
									option3="Fait"
									@btn-selected="updateTask(task, $event)"
								/>
							</div>
							<div class="vx-col px-0" style="width: 30px">
								<div
									v-if="$acl.check('accountmanager') && !task.document_count"
								>
									<vx-tooltip text="Ajouter un lien" position="top">
										<vs-button
											class="px-0"
											style="width: 30px"
											size="large"
											color="primary"
											type="flat"
											icon-pack="feather"
											icon="icon-plus-circle"
											@click="displayLinkPopup(task)"
											@update:popupActive="showLinkPopup = $event"
										></vs-button>
									</vx-tooltip>
								</div>
								<div v-if="task.document_count">
									<vx-tooltip text="Voir les documents partagés" position="top">
										<vs-button
											size="large"
											color="rgba(243, 222, 239, 0.4)"
											text-color="purple"
											type="flat"
											icon-pack="feather"
											icon="icon-file-text"
											@click="displayLinkPopup(task)"
											@update:popupActive="showLinkPopup = $event"
										></vs-button>
									</vx-tooltip>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="!$acl.check('accountmanager')"
						class="flex justify-center flex-wrap"
					>
						<vs-button
							@click="showMissionsforContract(contract.contract_id)"
							class="shadow-lg mt-2"
							type="filled"
							color="primary"
							>Détails des missions</vs-button
						>
					</div>
					<div
						v-if="$acl.check('accountmanager')"
						class="flex justify-center flex-wrap"
					>
						<vs-button
							@click="showHistory(society.society_id, contract.contract_id)"
							class="shadow-lg mt-2"
							type="filled"
							color="primary"
							>Historique</vs-button
						>
					</div>
				</vx-card>
			</vx-card>
		</div>
		<vs-popup
			:active.sync="showConfirmationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du document ?"
		>
			<div class="vx-row" style="z-index: 100 !important">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			:title="
				getSocietyName(society_id) +
				', Contrat N°' +
				contract_id +
				' : ' +
				getMissionProduct(mission_id)
			"
			:active.sync="showLinkPopup"
		>
			<ShareLinkPopup
				v-model="showLinkPopup"
				:apiUrl="apiUrl"
				:society_id="society_id"
				:mission_id="mission_id"
				:task_id="task_id"
				:contract_id="contract_id"
				@open-confirmation="confirmation(arguments)"
				ref="shareLink"
			/>
		</vs-popup>
	</div>
</template>

<script>
// import Vue from 'vue'
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import Mission from "@/entities/Mission";
import "@/assets/css/toggle-switch.css";

import ShareLinkPopup from "@/components/popups/ShareLinkPopup";
import SliderWith3btn from "@/components/widgets/SliderWith3btn";
import VxCard from "../../components/widgets/vx-card/VxCard.vue";

export default {
	name: "TasksCardTable",
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {
		VxCard,
		ShareLinkPopup,
		SliderWith3btn,
	},
	props: {
		societies: Array,
		tasks: Array,
	},
	computed: {
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		products: () => {
			return store.state.products;
		},
		allProductsCategories: () => {
			return store.state.products_categories;
		},
		allProductsSubCategories: () => {
			return store.state.products_sub_categories;
		},
	},
	data() {
		return {
			apiErrorMsg: null,
			apiUrl: this.$store.state.backendApiUrl,
			basicImgUrl: "task_default.png",
			showSocietyPopup: false,
			isContractMissionPopupActive: false,
			selectedSociety: null,
			selectedContract: null,
			selectedContractMissions: null,
			displayedSocieties: this.$props.societies,
			displayedTasks: [],
			contractsDelivery: [],
			contractsAccountManagers: [],
			missionsProduct: [],
			societyImageList: [],
			// links: [],
			showLinkPopup: false,
			society_id: null,
			mission_id: null,
			contract_id: null,
			task_id: null,
			showConfirmationPopup: false,
			docId: "",
		};
	},
	created() {
		this.displayTask();
		this.getAllProducts();
		this.getAllProductsCategories();
		this.getAllProductsSubCategories();
	},
	watch: {
		tasks: function () {
			this.displayTask();
		},
	},
	methods: {
		getAllProducts() {
			this.$store.dispatch("getAllProducts");
		},

		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},

		getAllProductsSubCategories() {
			this.$store.dispatch("getAllProductsSubCategories");
		},

		accept() {
			this.deleteDoc(this.docId);
			this.showConfirmationPopup = false;
		},
		calLen(commentary) {
			return commentary.length;
		},
		confirmation(param) {
			this.showConfirmationPopup = param[0];
			this.docId = param[1];
		},

		decline() {
			this.docId = "";
			this.showConfirmationPopup = false;
		},

		deleteDoc(docId) {
			this.$http
				.delete(this.apiUrl + "shared_document/delete/document/" + docId)
				.then(() => {
					this.$refs.shareLink.refreshList(this.task_id);
				});
		},
		displayLinkPopup(task) {
			this.showLinkPopup = this.showLinkPopup == true ? false : true;

			this.society_id = task.contract_society_id;
			this.task_id = task.id;
			this.contract_id = task.contract_id;
			this.mission_id = task.mission_id;

			/*
			 * this.$http.get(this.apiUrl + "shared_document/list/task/" + task.id)
			 * .then(result => {
			 *     this.links = result.data
			 *     this.showLinkPopup = true
			 * })
			 */

			this.showLinkPopup = true;
		},
		getProductPrestation(productId) {
			let foundProduct = this.products.find(
				(product) => product.id == productId
			);
			return foundProduct.perform;
		},
		showMissionsforContract(contract_id) {
			Mission.getMissionsForContract(contract_id, (err, res) => {
				this.selectedContract = contract_id;
				this.selectedContractMissions = res;
				this.isContractMissionPopupActive = true;
			});
		},

		/**
		 * Return month text abrevation from date
		 * @param {String} strDate - Date String format with T and Z as markers
		 * @return {String} - Date's month abreviation (FR)
		 */
		getMonthText(strDate) {
			let re = new RegExp("([T|Z])", "g");
			let strDateFormated = strDate.replace(re, " ");
			let date = new Date(strDateFormated);
			let retDate = this.getMonthName(date);
			return retDate.charAt(0).toUpperCase() + retDate.slice(1);
		},

		getFullDateText(strDate) {
			let re = new RegExp("([T|Z])", "g");
			let strDateFormated = strDate.replace(re, " ");
			let date = new Date(strDateFormated);
			let retDate = this.getMonthName(date);
			return (
				retDate.charAt(0).toUpperCase() +
				retDate.slice(1) +
				" " +
				date.getFullYear().toString().substring(2, 4)
			);
		},

		getFullDateNumber(strDate) {
			let strDateFormated = strDate.substring(0, 7).split("-").reverse();
			return (
				{
					"01": "Janvier",
					"02": "Février",
					"03": "Mars",
					"04": "Avril",
					"05": "Mai",
					"06": "Juin",
					"07": "Juillet",
					"08": "Août",
					"09": "Septembre",
					10: "Octobre",
					11: "Novembre",
					12: "Décembre",
				}[strDateFormated[0]] +
					" " +
					strDateFormated[1] || "" + strDateFormated[1]
			);
		},

		/**
		 * Fetch society by id
		 * @param {Number} societyId - The society id
		 */
		getSocietyById(societyId) {
			return this.$props.societies.find((society) => society.id == societyId);
		},
		/**
		 * Fetch society name by id
		 * @param {Number} societyId - The society id
		 */
		getSocietyName(societyId) {
			let foundSociety = this.getSocietyById(societyId);
			return foundSociety ? foundSociety.name : " ";
		},

		/**
		 * Fetch image if society.image is true else return false
		 * @param {Society} society - The society from which image is requested
		 */
		getSocietyImage(societyId) {
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					if (image.data.length > 0) {
						this.societyImageList.push({
							id: societyId,
							image: image.data,
						});
					}
				})
				.catch((err) => {
					//console.log(err);
				});
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		/**
		 * Get all contract IDs for all tasks
		 * @param {Object} tasks - Task List Object
		 * @return - Array of contract IDs
		 */
		getAllTasksContractIds(tasks) {
			// //console.log("getAllTasksContractIds")
			let contract_ids = [];
			for (let society of tasks) {
				for (let contract of society.contract_list) {
					// if(undefined == contract_ids.find(contract.contract_id)){
					contract_ids.push(contract.contract_id);
					// }
				}
			}
			return contract_ids;
		},

		/**
		 * Fetch Contract category by contract ID for a set of IDs
		 * @param {Object} tasks - Task List Object
		 */
		getContractCategoryByContractIdSet(tasks) {
			// //console.log("tasks", tasks)
			let string_contract_ids = JSON.stringify(
				this.getAllTasksContractIds(tasks)
			);
			// //console.log("string_contract_ids", string_contract_ids)
			if (string_contract_ids !== "[]") {
				this.$http
					.get(this.apiUrl + "contract/allcsd/", {
						params: {
							contractids: string_contract_ids,
						},
					})
					.then((res) => {
						// //console.log(res.data)
						this.contractsDelivery = res.data;
					})
					.catch((err) => {
						//console.log(err);
					});
			}
		},

		/**
		 * Get Contract Type from list by Contract ID
		 * @param {Number} contractId - ID of the contract to get category for
		 * @return {Number} - Contract's category ID
		 */
		getContractDelivery(contractId) {
			for (let contract of this.contractsDelivery) {
				if (contract.id == contractId) {
					return contract.delivery;
				}
			}
			return 0;
		},

		displaySocietyImage(societyId) {
			let foundImage = this.societyImageList.find(
				(society) => society.id == societyId
			);
			if (foundImage) return foundImage.image;
			else return this.basicImgUrl;
		},

		checkChanges(task, task_state) {
			// //console.log("checkChanges")
			task.archivate = task_state;
			// //console.log(task.archivate)
			if (task_state == "1" || task_state == "2") {
				this.changesHappened = true;
			}
		},

		displayTask() {
			/*
			 * POUR CHAQUE TACHE
			 *  console.time("displayTask")
			 */
			let contract_list = [];
			for (let task of this.$props.tasks) {
				//  GROUPER PAR CONTRAT
				if (contract_list.length > 0) {
					let foundContractIndex = contract_list.findIndex(
						(contract_list_obj) =>
							task.contract_id == contract_list_obj.contract_id
					);
					if (foundContractIndex >= 0) {
						contract_list[foundContractIndex].task_list.push(
							JSON.parse(JSON.stringify(task))
						);
					} else {
						let contract_list_obj = {
							contract_id: task.contract_id,
							society_id: task.contract_society_id,
							task_list: [JSON.parse(JSON.stringify(task))],
						};
						contract_list.push(contract_list_obj);
					}
				} else {
					let contract_list_obj = {
						contract_id: task.contract_id,
						society_id: task.contract_society_id,
						task_list: [JSON.parse(JSON.stringify(task))],
					};
					contract_list.push(contract_list_obj);
				}
			}
			//  GROUPER LES CONTRATS PAR SOCIETE
			let society_list = [];
			for (let contract of contract_list) {
				if (society_list.length > 0) {
					let foundSocietyIndex = society_list.findIndex(
						(society_list_obj) =>
							contract.society_id == society_list_obj.society_id
					);
					if (foundSocietyIndex >= 0) {
						// if(society_list.find(society_list_obj => contract.society_id == society_list_obj.society_id)){
						society_list[foundSocietyIndex].contract_list.push(contract);
					} else {
						this.getSocietyImage(contract.society_id);
						let society_list_obj = {
							society_id: contract.society_id,
							contract_list: [contract],
						};
						society_list.push(society_list_obj);
					}
				} else {
					this.getSocietyImage(contract.society_id);
					let society_list_obj = {
						society_id: contract.society_id,
						society_name: this.getSocietyName(contract.society_id),
						contract_list: [contract],
					};
					society_list.push(society_list_obj);
				}
			}
			//  RESERVER DANS displayedTasks
			this.displayedTasks = [];
			this.displayedTasks = [...society_list];
			this.getContractCategoryByContractIdSet(this.displayedTasks);
			this.getProductDescriptionByMissionIdSet(this.displayedTasks);
			this.getContractAccoutManagersByContractIdSet(this.displayedTasks);
			// console.timeEnd("displayTask")
		},

		/**
		 * Make list of AM list object group by contract Id
		 * @param {Array} account_managers - list of account manager associated with contract IDs
		 * @return {Array} - list of contract containing account manager list
		 */
		groupAccountManagersByContractId(account_managers) {
			let contract_list = [];
			for (let account_manager of account_managers) {
				if (contract_list.length > 0) {
					// for(let contract)
					let foundContractIndex = contract_list.findIndex(
						(contract_list_obj) =>
							account_manager.contracts_id == contract_list_obj.contract_id
					);
					if (foundContractIndex >= 0) {
						/*
						 * //console.log("found obj")
						 * //console.log("contract_list.task_list", contract_list)
						 */
						contract_list[foundContractIndex].account_manager_list.push(
							JSON.parse(
								JSON.stringify({
									id: account_manager.id,
									firstname: account_manager.firstname,
									lastname: account_manager.lastname,
								})
							)
						);
					} else {
						// //console.log("did not found obj")
						contract_list.push({
							account_manager_list: [
								{
									id: account_manager.id,
									firstname: account_manager.firstname,
									lastname: account_manager.lastname,
								},
							],
							contract_id: account_manager.contracts_id,
						});
					}
				} else {
					contract_list.push({
						account_manager_list: [
							{
								id: account_manager.id,
								firstname: account_manager.firstname,
								lastname: account_manager.lastname,
							},
						],
						contract_id: account_manager.contracts_id,
					});
				}
			}
			return contract_list;
		},

		/**
		 * Fetch Contract account managers by contract ID for a set of IDs
		 * @param {Object} tasks - Task List Object
		 */
		getContractAccoutManagersByContractIdSet(tasks) {
			let string_contract_ids = JSON.stringify(
				this.getAllTasksContractIds(tasks)
			);
			if (string_contract_ids !== "[]") {
				this.$http
					.get(this.apiUrl + "users/all/amcfs", {
						params: {
							contractids: string_contract_ids,
						},
					})
					.then((res) => {
						/*
						 *  //console.log(res.data)
						 * GROUP BY CONTRACT
						 */
						this.contractsAccountManagers =
							this.groupAccountManagersByContractId(res.data);
					})
					.catch((err) => {
						//console.log(err);
					});
			}
		},

		/**
		 * Get account manager list for the contract ID
		 * @param {Number} contractId - ID of the contract to get account managers from
		 * @return {Array} - Array of account manager of the contract
		 */
		getAMForContractId(contractId) {
			let foundContract = this.contractsAccountManagers.find(
				(contract) => contract.contract_id == contractId
			);
			if (foundContract) {
				// //console.log(foundContract)
				return foundContract.account_manager_list;
			}
			return [];
		},

		/**
		 * Get all Mission IDs for all tasks
		 * @param {Object} tasks - Task List Object
		 * @return - Array of contract IDs
		 */
		getAllTasksMissionIds(tasks) {
			let mission_ids = [];
			for (let society of tasks) {
				for (let contract of society.contract_list) {
					for (let task of contract.task_list) {
						mission_ids.push(task.mission_id);
					}
				}
			}
			return mission_ids;
		},

		/**
		 * Fetch Missions descriptions by mission ID for a set of IDs
		 * @param {Object} tasks - Task List Object
		 */
		getProductDescriptionByMissionIdSet(tasks) {
			let string_mission_ids = JSON.stringify(
				this.getAllTasksMissionIds(tasks)
			);
			// //console.log("string_contract_ids", string_mission_ids)
			if (string_mission_ids !== "[]") {
				this.$http
					.get(this.apiUrl + "mission/allpdesc/", {
						params: {
							missionids: string_mission_ids,
						},
					})
					.then((res) => {
						// //console.log(res.data)
						this.missionsProduct = res.data;
					})
					.catch((err) => {
						//console.log(err);
					});
			}
		},

		/**
		 * Get Contract Type from list by Contract ID
		 * @param {Number} contractId - ID of the contract to get category for
		 * @return {Number} - Contract's category ID
		 */
		getMissionProduct(missionId) {
			for (let mission of this.missionsProduct) {
				if (mission.id == missionId) {
					return mission.perform;
				}
			}
			return " ";
		},

		/**
		 * Update changed task
		 * @param {Object}
		 */
		updateTask(task, task_state) {
			//console.log("task", task, task_state);

			let today = new Date(Date.now());
			let strtoday = today.toISOString();
			/*
			 * today = today.substring(0,10)
			 * today = today + " 02:00:00"
			 */

			let re = new RegExp("([T|Z])", "g");
			let creation_date = task.creation_date.replace(re, " ");
			strtoday = strtoday.replace(re, " ");
			let finished_date = task_state > 0 ? strtoday : null;

			this.$http
				.post(this.apiUrl + "task/edit/" + task.id, {
					commentary: task.commentary,
					link: task.link,
					status: task.status,
					creation_date: creation_date,
					finished_date: finished_date,
					recurrence: task.recurrence,
					frequency: task.frequency,
					archivate: task_state,
					contract_id: task.contract_id,
					contract_society_id: task.contract_society_id,
					mission_id: task.mission_id,
				})
				.then((res) => {
					//console.log("resTask", res);
					if (!task.recurrence || task.recurrence == 0) {
						let mission_status = 1;
						if (task_state == 1) {
							mission_status = 7;
						} else if (task_state == 0) {
							mission_status = 1;
						} else if (task_state == 2) {
							mission_status = 5;
						}
						this.$http
							.post(this.apiUrl + "mission/editarch", {
								contract_id: task.contract_id,
								status: mission_status,
								id: task.mission_id,
							})
							.then((res) => {
								//console.log("resMission", res);
								this.$vs.notify({
									title: "Succès",
									text: "Tâche modifiée avec succès.",
								});
								// this.$emit("update-task", [task, task_state]);
							})
							.catch((err) => {
								//console.log(err);
								this.$vs.notify({
									title: "Echec",
									text: "La tâche n'a pas été modifiée.",
								});
							});
					} else {
						this.$vs.notify({
							title: "Succès",
							text: "Tâche modifiée avec succès.",
						});
						// this.$emit("update-task", [task, task_state]);
					}
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "La tâche n'a pas été modifiée.",
					});
				});
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},
		displaySocietyPopup(society) {
			society.image = this.displaySocietyImage(society.id);
			this.$emit("show-society-popup", society);
		},
		displayContractPopup(contract) {
			this.$emit("show-contract-popup", contract);
		},
		/**
		 * Shows popup of tasks for a society
		 * @param {Number} societyId - Society to show history for.
		 */
		showHistory(societyId, contractId = null) {
			this.$emit("show-history-popup", societyId, contractId);
			// //console.log(societyId)
		},
		showCommentary(commentary) {
			return commentary.substr(0, 35) + "...";
		},
	},
};
</script>

<style scoped>
.hvr-blue:hover {
	color: white;
	background-color: aqua;
}

.hvr-reveal {
	display: inline-block;
	vertical-align: middle;
	-webkit-transform: perspective(1px) translateZ(0);
	transform: perspective(1px) translateZ(0);
	box-shadow: 0 0 1px rgba(0, 0, 0, 0);
	position: relative;
	overflow: hidden;
}
.hvr-reveal:before {
	content: "";
	position: absolute;
	z-index: -1;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	border-color: #00ccff;
	border-style: solid;
	border-width: 0;
	-webkit-transition-property: border-width;
	transition-property: border-width;
	-webkit-transition-duration: 0.1s;
	transition-duration: 0.1s;
	-webkit-transition-timing-function: ease-out;
	transition-timing-function: ease-out;
}
.hvr-reveal:hover:before,
.hvr-reveal:focus:before,
.hvr-reveal:active:before {
	-webkit-transform: translateY(0);
	transform: translateY(0);
	border-width: 4px;
}

.center-content {
	display: flex;
	justify-content: center;
	align-items: center;
}

.vs-tooltip.vs-tooltip-top.vs-tooltip-null {
	word-break: break-all;
}
</style>